import React from 'react'
import SVG from 'react-inlinesvg'
import { iconType } from 'common/types'
import StyledIcon from './StyledIcon'

const url = src => require(`assets/icons/${src}`)

const Icon = ({ children, src, svg, family = 'fas', name, ...props }) =>
  src ? (
    svg ? (
      <SVG src={url(src)} {...props} />
    ) : (
      <img src={url(src)} {...props} />
    )
  ) : (
    <StyledIcon {...props}>
      <i className={`${family} fa-${name}`} />
      {children && <span className="text">{children}</span>}
    </StyledIcon>
  )

Icon.propTypes = iconType

export default Icon
